module.exports = __webpack_public_path__ + "dbc801dfed29e24c9c733baf71107b60.pdf";